import Vue from 'vue'

import axios from 'axios'
import ElementUI from 'element-ui'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.prototype.$http=axios
Vue.use(ElementUI)
// 关闭 点击遮罩关闭弹出层 功能
ElementUI.Dialog.props.closeOnClickModal.default = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
